import { create } from 'zustand';

/**
 * Minimal app-wide toast queue. Mobile renders toasts above the bottom tab
 * bar (android-app-plan §6.3); used first by the back-button "press again to
 * exit" hint (M2.5), later by offline write-block messages (M4.4).
 */
export interface Toast {
  id: number;
  message: string;
}

const TOAST_DURATION_MS = 2500;

interface ToastState {
  toasts: Toast[];
  show: (message: string) => void;
  dismiss: (id: number) => void;
}

let nextToastId = 1;

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  show: (message) => {
    nextToastId += 1;
    const id = nextToastId;
    set((s) => ({ toasts: [...s.toasts, { id, message }] }));
    setTimeout(() => {
      set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
    }, TOAST_DURATION_MS);
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));
